import React from "react";
import { User } from "../../../types";
import { useTranslation } from "react-i18next";
import SelectCard from "../SelectCard";

interface GenderStepProps {
  gender?: User["gender"];
  onSelect: (gender: "male" | "female") => void;
}

const GenderStep: React.FC<GenderStepProps> = ({ gender, onSelect }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full justify-center px-4">
      <div className="text-center mb-8">
        <h2 className="heading-display mb-2">{t("wizard.gender.title")}</h2>
        <p className="text-sm text-content-tertiary font-medium">
          {t("wizard.gender.subtitle")}
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4">
        <SelectCard
          selected={gender === "male"}
          onClick={() => onSelect("male")}
          icon="👨"
          title={t("wizard.gender.male")}
          index={0}
        />
        <SelectCard
          selected={gender === "female"}
          onClick={() => onSelect("female")}
          icon="👩"
          title={t("wizard.gender.female")}
          index={1}
        />
      </div>
    </div>
  );
};

export default GenderStep;
